import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import Row from '../../../../core/layout/Row';
import Select from '../../../../core/form/Select';
import Column from '../../../../core/layout/Column';
import Divider from '../../../../core/layout/Divider';
import TextInput from '../../../../core/form/TextInput';
import TranslationInputContainer from '../inputs/TranslationInputContainer';
import AnswersInputContainer from '../inputs/AnswersInputContainer';
import SpellCheckInputContainer from '../inputs/SpellCheckInputContainer';

class DialogueItemForm extends React.Component {
  static propTypes = {
    values: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.object,
    submitting: PropTypes.bool,
    disabled: PropTypes.bool,
    type: PropTypes.oneOf(['DIALOGUE', 'DIALOGUE_OPTION']).isRequired,
  };

  static defaultProps = {
    values: {},
    errors: {},
    submitting: false,
    disabled: false,
  };

  shouldComponentUpdate(nextProps) {
    return JSON.stringify(nextProps) !== JSON.stringify(this.props);
  }

  componentDidUpdate() {
    if (this.props.type === 'DIALOGUE_OPTION') {
      this.props.onChange('dialogueCharacter', 'STUDENT');
    }
  }

  componentDidMount() {
    if (this.props.type === 'DIALOGUE_OPTION') {
      this.props.onChange('dialogueCharacter', 'STUDENT');
    }
  }

  render() {
    return (
      <div>
        <Row>
          <Column size={3}>
            <Select
              required
              label="Dialogue Character"
              disabled={
                this.props.submitting ||
                this.props.disabled ||
                this.props.type === 'DIALOGUE_OPTION'
              }
              value={
                this.props.type === 'DIALOGUE_OPTION'
                  ? 'STUDENT'
                  : get(this.props.values, 'dialogueCharacter', '')
              }
              onChange={value =>
                this.props.onChange('dialogueCharacter', value)
              }
              errorText={get(this.props.errors, 'dialogueCharacter', '')}
              options={[
                { value: 'CHARACTER', label: 'Character' },
                { value: 'STUDENT', label: 'Student' },
              ]}
            />
          </Column>
        </Row>
        <Row>
          <Column size={12}>
            <TextInput
              required
              label="Text"
              fieldType="textarea"
              disabled={this.props.submitting || this.props.disabled}
              value={get(this.props.values, 'text', '')}
              onChange={value => this.props.onChange('text', value)}
              errorText={get(this.props.errors, 'text', '')}
            />
          </Column>
        </Row>
        {this.props.type === 'DIALOGUE_OPTION' && (
          <Row>
            <Column size={12}>
              <SpellCheckInputContainer
                onChange={this.props.onChange}
                submitting={this.props.submitting}
                values={this.props.values}
                disabled={this.props.disabled}
              />
            </Column>
          </Row>
        )}
        <TranslationInputContainer
          onChange={this.props.onChange}
          submitting={this.props.submitting}
          values={this.props.values}
          errors={this.props.errors}
          disabled={this.props.disabled}
        />
        {this.props.type === 'DIALOGUE_OPTION' && (
          <>
            <Divider title="Incorrect Options" />
            <AnswersInputContainer
              label="Text"
              value={get(this.props.values, 'answers', [])}
              onChange={answers => this.props.onChange('answers', answers)}
              errorText={get(this.props.errors, 'answers', '')}
              disabled={this.props.disabled}
              answerType="WRONG"
              hasImage={false}
              allowAudio={false}
              allowSpellCheck={true}
            />
          </>
        )}
      </div>
    );
  }
}

export default DialogueItemForm;
